import { Linking, Platform } from "react-native";
//import { setJSExceptionHandler } from "react-native-exception-handler";
import Constants from "expo-constants";
import { getVersion } from "./version";
import { AppConfig, setAppConfig } from "./globals";
import { Environment } from "common247";

export async function initMemories(): Promise<void> {
  // This will log in Browser console - NOT in the terminal!
  console.log("initMemories", "Extra", Constants.expoConfig?.extra, "Env", Constants.expoConfig?.extra?.env,
    "FIREBASE_CONFIG", process.env.FIREBASE_CONFIG, "EnvEnv", process.env.ENV);

  //process.env.ENV is undefined
  //const env = new Environment(process.env.ENV);

  //JJ - When we deploy web we do not have all these environment variables - so instead we add them to the
  // Expo config in app.config.ts.
  // So we can use them here...
  const vars = Constants.expoConfig?.extra!;

  // 2026-06-23T05:40:21.134Z
  // TypeError: Invalid URL: null
  //   at URL (address at index.android.bundle:1:591805)
  //   at ?anon_0_initMemories (address at index.android.bundle:1:2323558)
  // When running as Android App! Do we need the environment? Is it bundled?
  let env: Environment;
  let url: URL;
  if (Platform.OS === "web") {
    console.log("Web OS - getting URL");
    const base = await Linking.getInitialURL();
    url = new URL(base!);
    console.log("Running from", base, "Host", url.host);
  } else {
    console.log("Mobile OS - using hardcoded URL");
    const base = "https://dev.memories.on247.net";
    url = new URL(base);
  }

  // Set up our web base URL
  const config: AppConfig = {
    ...vars,
    environ: new Environment(vars.env),
    domain: url.host!, //"memories-dev-247.web.app" "localhost:8081",
    productVersion: vars.productVersion,
    appVersion: vars.appVersion,
  };
  setAppConfig(config);

  console.log("Config", Constants.expoConfig, `AppVer=${config.appVersion} ProductVer=${config.productVersion}`, `Env=${config.environ.getName().toUpperCase()}`, `NodeEnv=${process.env.NODE_ENV}`, getVersion());
  console.log("Constants.executionEnvironment", Constants.executionEnvironment);

  // setJSExceptionHandler((error, isFatal) => {
  //   console.error(error);
  //   if (isFatal) {
  //     CustomAlert.alert("Fatal Error", "Something went terribly wrong. Please restart the app.");
  //   }
  // });
}
